import { render, staticRenderFns } from "./PitchDayRespostas.vue?vue&type=template&id=64ec70c4&scoped=true"
import script from "./PitchDayRespostas.vue?vue&type=script&lang=js"
export * from "./PitchDayRespostas.vue?vue&type=script&lang=js"
import style0 from "./PitchDayRespostas.vue?vue&type=style&index=0&id=64ec70c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ec70c4",
  null
  
)

export default component.exports